<div
  class="ngsild-upload-files"
  [class.ngsild-upload-files--modal]="layout() === 'modal'"
>
  @if (banner(); as b) {
    <div
      class="ngsild-upload-files__banner"
      [class.ngsild-upload-files__banner--success]="b.type === 'success'"
      [class.ngsild-upload-files__banner--error]="b.type === 'error'"
      role="status"
    >
      <span>{{ b.text }}</span>
      <button type="button" class="ngsild-upload-files__banner-close" (click)="dismissBanner()" aria-label="Dismiss">
        ×
      </button>
    </div>
  }

  @if (layout() === 'modal' && isLoadingExistingAssetRequest()) {
    <p class="ngsild-upload-files__existing-status" role="status" aria-live="polite">
      Loading saved configuration…
    </p>
  }

  @if (layout() === 'modal' && existingUploadConfigReadOnly()) {
    <p class="ngsild-upload-files__existing-hint" role="note">
      Showing the configuration you submitted earlier. Fields are read-only; close this dialog when finished.
    </p>
  }

  @if (layout() === 'modal' && isExistingDataSourceReadOnly()) {
    <p class="ngsild-upload-files__existing-hint" role="note">
      Showing the Data Source URL connected to this asset. This field is read-only; close this dialog when finished.
    </p>
  }

  <div
    class="step-content"
    [class.step-content--add-data-modal]="layout() === 'modal'"
  >
    @if (layout() === 'default') {
      <h2 class="step-title">Upload Data</h2>
    }

    @if (layout() === 'modal' && showModalTabBar()) {
      <div class="add-data-modal__chrome">
        <div class="add-data-modal__mode-tabs" role="tablist" aria-label="Connection type">
          @for (tab of modalTabs(); track tab.id) {
            <button
              type="button"
              role="tab"
              class="add-data-modal__mode-tab"
              [attr.aria-selected]="selectedUploadOption() === tab.id"
              [class.add-data-modal__mode-tab--active]="selectedUploadOption() === tab.id"
              (click)="selectModalTab(tab.id)"
            >
              <span class="add-data-modal__mode-tab-icon" aria-hidden="true">
                @if (tab.icon === 'upload') {
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M7 14L12 9L17 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 9V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                }
                @if (tab.icon === 'sftp') {
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="currentColor"
                      stroke-width="2"
                    />
                    <path d="M8 12H16M12 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  </svg>
                }
                @if (tab.icon === 'api') {
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7C4 7 5 4 12 4C19 4 20 7 20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M4 17C4 17 5 20 12 20C19 20 20 17 20 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                  </svg>
                }
                @if (tab.icon === 'push') {
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 12L12 3L21 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 3V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                }
                @if (tab.icon === 'data-source') {
                  <svg class="add-data-modal__octocat" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill="currentColor"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                    />
                  </svg>
                }
              </span>
              <span class="add-data-modal__mode-tab-title">{{ tab.label }}</span>
            </button>
          }
          @if (modalDatasetLabel()) {
            <p class="add-data-modal__dataset-label">
              {{ modalAssetKindLabel() }}: <strong>{{ modalDatasetLabel() }}</strong>
            </p>
          }
        </div>
      </div>
    }

    <div class="upload-layout" [class.upload-layout--wizard]="layout() === 'default'">
      @if (layout() === 'default') {
        <aside class="upload-split__sidebar" aria-label="Upload method">
          <div class="upload-method">
            <p class="upload-method__legend" id="upload-method-legend">How would you like to add data?</p>
            <div class="upload-method__list" role="radiogroup" aria-labelledby="upload-method-legend">
              @for (option of allUploadMethodOptions; track option.value) {
                @if (isUploadMethodAllowed(option.value)) {
                <button
                  type="button"
                  role="radio"
                  class="upload-method__item"
                  [class.upload-method__item--active]="selectedUploadOption() === option.value"
                  [attr.aria-checked]="selectedUploadOption() === option.value ? 'true' : 'false'"
                  [attr.aria-label]="option.label + '. ' + option.description"
                  (click)="selectUploadOption(option.value)"
                >
                  <span class="upload-method__item-icon" aria-hidden="true">
                    @if (option.icon === 'upload') {
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path d="M7 14L12 9L17 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 9V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    }
                    @if (option.icon === 'sftp') {
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path d="M8 12H16M12 8V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    }
                    @if (option.icon === 'api') {
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 7C4 7 5 4 12 4C19 4 20 7 20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4 17C4 17 5 20 12 20C19 20 20 17 20 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    }
                    @if (option.icon === 'push') {
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 12L12 3L21 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 3V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    }
                  </span>
                  <span class="upload-method__item-body">
                    <span class="upload-method__item-title">{{ option.label }}</span>
                  </span>
                </button>
                }
              }
            </div>
          </div>
        </aside>
      }

      <div class="upload-split__main" [class.upload-split__main--modal]="layout() === 'modal'">
        @if (layout() === 'modal' && isDataSourceTabSelected() && (isDataSourceUrlEnabled() || isExistingDataSourceReadOnly())) {
          <div class="add-data-modal__connect">
            <form class="add-data-modal__connect-form" [formGroup]="dataSourceUrlForm" (ngSubmit)="onSubmitDataSourceUrlForm()">
              <div class="form-field">
                <label for="ngsild-data-source-repo-url" class="form-label add-data-modal__connect-label">
                  Repository / Data Source URL <span class="required">*</span>
                </label>
                <input
                  id="ngsild-data-source-repo-url"
                  type="url"
                  class="form-input add-data-modal__connect-input"
                  formControlName="repositoryUrl"
                  placeholder="Paste your Data Source URL"
                  autocomplete="off"
                  spellcheck="false"
                  [readonly]="isExistingDataSourceReadOnly()"
                />
                @if (
                  dataSourceUrlForm.get('repositoryUrl')?.invalid &&
                  (dataSourceUrlForm.get('repositoryUrl')?.dirty ||
                    dataSourceUrlForm.get('repositoryUrl')?.touched)
                ) {
                  <div class="error-message">
                    @if (dataSourceUrlForm.get('repositoryUrl')?.errors?.['required']) {
                      URL is required.
                    } @else if (dataSourceUrlForm.get('repositoryUrl')?.errors?.['httpsUrl']) {
                      URL must start with https://
                    }
                  </div>
                }
              </div>
            </form>
          </div>
        } @else {
          @if (layout() === 'default' && activeUploadMethod(); as active) {
            @for (k of [methodHintAnimationKey()]; track k) {
              <p class="upload-method__hint" aria-live="polite">{{ active.description }}</p>
            }
          }

        @if (isUploadFileSelected()) {
      <div class="file-upload-section" [class.file-upload-section--modal-reflow]="layout() === 'modal'">
        @if (layout() === 'default') {
          <div class="file-upload-header">
            <h3 class="file-upload-title">Upload Files</h3>
            <p class="file-upload-subtitle">Select multiple files to upload</p>
          </div>
        }

        <div class="file-upload-area" [class.file-upload-area--modal]="layout() === 'modal'">
          <input
            #ngsildFileInput
            type="file"
            id="ngsild-dataset-file-input"
            multiple
            [attr.accept]="getAcceptAttribute()"
            (change)="onFileSelected($event)"
            class="file-input"
          />
          <label
            for="ngsild-dataset-file-input"
            class="file-upload-label"
            [class.file-upload-label--drag-active]="isDropzoneActive()"
            (dragover)="onDropZoneDragOver($event)"
            (dragenter)="onDropZoneDragEnter($event)"
            (dragleave)="onDropZoneDragLeave($event)"
            (drop)="onDropZoneDrop($event)"
          >
            <div class="file-upload-icon" [class.file-upload-icon--modal]="layout() === 'modal'">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M7 14L12 9L17 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 9V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            @if (layout() === 'modal') {
              <p class="file-upload-text file-upload-text--modal">
                <strong>Click to upload</strong> or drag and drop
              </p>
              <p class="file-upload-hint file-upload-hint--modal">
                Allowed: <strong class="file-upload-hint-fmt">{{ getModalPrimaryFormatLabel() }}</strong>
              </p>
            } @else {
              <p class="file-upload-text">Click to browse or drag and drop files here</p>
              <p class="file-upload-hint">Allowed: {{ getAllowedFileTypesLabel() }} (chosen in Step 3 + CSV, TXT)</p>
            }
          </label>
          @if (layout() === 'modal') {
            <button type="button" class="file-upload-browse-btn" (click)="openFilePicker(ngsildFileInput)">Browse files</button>
          }
        </div>

        @if (hasFilesToShow()) {
          <div class="selected-files-list">
            <div class="selected-files-header">
              <h4 class="selected-files-title">{{ selectedFilesTitle() }}</h4>
            </div>

            @if (uploadedFiles().length > 0 && selectedFiles().length > 0) {
              <h5 class="section-subtitle">Uploaded Files ({{ uploadedFiles().length }})</h5>
            }

            @if (uploadedFiles().length > 0) {
              <div class="uploaded-files-container">
                @for (fileItem of uploadedFiles(); track fileItem.file.name + '-' + fileItem.file.size) {
                  <div
                    class="uploaded-file-item"
                    [class.completed]="fileItem.status === 'completed'"
                    [class.error]="fileItem.status === 'error'"
                  >
                    <div class="file-info">
                      <div class="file-icon">
                        @if (fileItem.status !== 'completed') {
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        } @else {
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 6L9 17L4 12" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        }
                      </div>
                      <div class="file-details">
                        <span class="file-name">{{ fileItem.file.name }}</span>
                        <span class="file-size">{{ getFileSize(fileItem.file.size) }}</span>
                      </div>
                    </div>
                    <div class="file-actions">
                      <span
                        class="file-status"
                        [class.status-pending]="fileItem.status === 'pending'"
                        [class.status-uploading]="fileItem.status === 'uploading'"
                        [class.status-completed]="fileItem.status === 'completed'"
                        [class.status-error]="fileItem.status === 'error'"
                      >
                        {{ fileItem.progress }}%
                      </span>
                      @if (hasPreviewData(fileItem)) {
                        <button
                          type="button"
                          class="btn-preview"
                          (click)="openFilePreview(fileItem)"
                          title="View Preview"
                        >
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M1 8C1 8 3 3 8 3C13 3 15 8 15 8C15 8 13 13 8 13C3 13 1 8 1 8Z"
                              stroke="currentColor"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle cx="8" cy="8" r="2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          Preview
                        </button>
                      }
                      <button
                        type="button"
                        class="btn-icon btn-delete-file"
                        (click)="deleteUploadedFile(fileItem)"
                        title="Delete File"
                        [disabled]="uploading()"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                    @if (fileItem.status === 'uploading') {
                      <div class="progress-bar">
                        <div class="progress-fill" [style.width.%]="fileItem.progress"></div>
                      </div>
                    }
                    @if (fileItem.error) {
                      <div class="file-error">{{ fileItem.error }}</div>
                    }
                  </div>
                }
                @if (isAllUploadsCompleted() && !isPublished()) {
                  <div class="post-upload-actions">
                    <button type="button" class="btn btn-secondary" (click)="uploadMoreFiles(ngsildFileInput)">
                      Upload More
                    </button>
                  </div>
                }
              </div>
            }

            @if (selectedFiles().length > 0) {
              @if (uploadedFiles().length > 0) {
                <h5 class="section-subtitle">Newly Selected Files ({{ selectedFiles().length }})</h5>
              }
              <div class="selected-files-container">
                @for (file of selectedFiles(); track file.name + '-' + file.size + '-' + $index; let i = $index) {
                  <div class="selected-file-item">
                    <div class="file-info">
                      <div class="file-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div class="file-details">
                        <span class="file-name">{{ file.name }}</span>
                        <span class="file-size">{{ getFileSize(file.size) }}</span>
                      </div>
                    </div>
                    <div class="file-actions-buttons">
                      <button
                        type="button"
                        class="btn-icon btn-upload"
                        (click)="uploadSingleFileFromSelected(i)"
                        title="Upload this file"
                        [disabled]="uploading()"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M14 10v2.667A1.333 1.333 0 0 1 12.667 14H3.333A1.333 1.333 0 0 1 2 12.667V10M11.333 5.333 8 2m0 0L4.667 5.333M8 2v8"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                      <button
                        type="button"
                        class="btn-icon btn-delete-file"
                        (click)="removeFile(i)"
                        title="Delete this file"
                        [disabled]="uploading()"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M2 4H14M5.333 4V2.667C5.333 2.313 5.474 1.974 5.724 1.724C5.974 1.474 6.313 1.333 6.667 1.333H9.333C9.687 1.333 10.026 1.474 10.276 1.724C10.526 1.974 10.667 2.313 10.667 2.667V4M12.667 4V13.333C12.667 13.687 12.526 14.026 12.276 14.276C12.026 14.526 11.687 14.667 11.333 14.667H4.667C4.313 14.667 3.974 14.526 3.724 14.276C3.474 14.026 3.333 13.687 3.333 13.333V4H12.667Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                }
              </div>

              <div class="file-list-actions">
                <button type="button" class="btn btn-clear" (click)="clearAllFiles()" [disabled]="uploading()">
                  {{ clearSelectedFilesLabel() }}
                </button>
                <button type="button" class="btn btn-primary" (click)="uploadAllFiles()" [disabled]="uploading()">
                  {{ uploadSelectedFilesLabel() }}
                </button>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (isSftpUploadSelected()) {
      <div class="sftp-upload-section">
        <form [formGroup]="sftpForm" (ngSubmit)="onSubmitSftpForm()">
          <div class="form-fields">
            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-sftp-host" class="form-label">
                  SFTP Host <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="ngsild-sftp-host"
                  formControlName="sftpHost"
                  class="form-input"
                  placeholder="Enter SFTP host"
                />
                @if (sftpForm.get('sftpHost')?.invalid && sftpForm.get('sftpHost')?.touched) {
                  <div class="error-message">SFTP Host is required</div>
                }
              </div>
              <div class="form-field col-6">
                <label for="ngsild-sftp-port" class="form-label">
                  Port <span class="required">*</span>
                </label>
                <input type="text" id="ngsild-sftp-port" formControlName="port" class="form-input" placeholder="Enter port number" />
                @if (sftpForm.get('port')?.invalid && sftpForm.get('port')?.touched) {
                  <div class="error-message">Valid port number is required</div>
                }
              </div>
            </div>

            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-sftp-username" class="form-label">
                  Username <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="ngsild-sftp-username"
                  formControlName="username"
                  class="form-input"
                  placeholder="Enter username"
                />
                @if (sftpForm.get('username')?.invalid && sftpForm.get('username')?.touched) {
                  <div class="error-message">Username is required</div>
                }
              </div>
              <div class="form-field col-6">
                <label for="ngsild-sftp-password" class="form-label">
                  Password <span class="required">*</span>
                </label>
                <input
                  type="password"
                  id="ngsild-sftp-password"
                  formControlName="password"
                  class="form-input"
                  placeholder="Enter password"
                />
                @if (sftpForm.get('password')?.invalid && sftpForm.get('password')?.touched) {
                  <div class="error-message">Password is required</div>
                }
              </div>
            </div>

            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-sftp-remote-path" class="form-label">
                  Remote Path <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="ngsild-sftp-remote-path"
                  formControlName="remotePath"
                  class="form-input"
                  placeholder="Enter remote path"
                />
                @if (sftpForm.get('remotePath')?.invalid && sftpForm.get('remotePath')?.touched) {
                  <div class="error-message">Remote Path is required</div>
                }
              </div>
              <div class="form-field col-6">
                <label for="ngsild-sftp-local-path" class="form-label">
                  Local File Path <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="ngsild-sftp-local-path"
                  formControlName="localFilePath"
                  class="form-input"
                  placeholder="Enter local file path"
                />
                @if (sftpForm.get('localFilePath')?.invalid && sftpForm.get('localFilePath')?.touched) {
                  <div class="error-message">Local File Path is required</div>
                }
              </div>
            </div>

            <div class="form-field">
              <label for="ngsild-sftp-notes" class="form-label">Optional Notes/Description</label>
              <textarea
                id="ngsild-sftp-notes"
                formControlName="optionalNotes"
                class="form-textarea"
                rows="4"
                placeholder="Enter any additional notes or description (optional)"
              ></textarea>
            </div>
          </div>
        </form>
      </div>
    }

    @if (isApiIntegrationSelected()) {
      <div class="api-integration-section">
        <form [formGroup]="apiIntegrationForm">
          <div class="form-fields">
            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-api-source-name" class="form-label">
                  Data Source Name <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="ngsild-api-source-name"
                  formControlName="dataSourceName"
                  class="form-input"
                  placeholder="Enter data source name"
                />
                @if (apiIntegrationForm.get('dataSourceName')?.invalid && apiIntegrationForm.get('dataSourceName')?.touched) {
                  <div class="error-message">Data Source Name is required</div>
                }
              </div>
              <div class="form-field col-6">
                <label for="ngsild-api-base-url" class="form-label">
                  API Base URL <span class="required">*</span>
                </label>
                <input
                  type="url"
                  id="ngsild-api-base-url"
                  formControlName="apiBaseUrl"
                  class="form-input"
                  placeholder="https://api.example.com"
                  autocomplete="off"
                  spellcheck="false"
                  [class.error]="apiIntegrationForm.get('apiBaseUrl')?.invalid && apiIntegrationForm.get('apiBaseUrl')?.touched"
                />
                @if (apiIntegrationForm.get('apiBaseUrl')?.invalid && apiIntegrationForm.get('apiBaseUrl')?.touched) {
                  <div class="error-message">
                    @if (apiIntegrationForm.get('apiBaseUrl')?.errors?.['required']) {
                      API Base URL is required.
                    } @else if (apiIntegrationForm.get('apiBaseUrl')?.errors?.['invalidUrl']) {
                      Enter a valid URL starting with http:// or https://
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-api-endpoint" class="form-label">
                  Endpoint Path <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="ngsild-api-endpoint"
                  formControlName="endpointPath"
                  class="form-input"
                  placeholder="Enter endpoint path"
                />
                @if (apiIntegrationForm.get('endpointPath')?.invalid && apiIntegrationForm.get('endpointPath')?.touched) {
                  <div class="error-message">Endpoint Path is required</div>
                }
              </div>
              <div class="form-field col-6">
                <label for="ngsild-api-http-method" class="form-label">
                  HTTP Method <span class="required">*</span>
                </label>
                <div class="custom-dropdown-wrapper">
                  <div
                    id="ngsild-api-http-method"
                    class="custom-dropdown-trigger"
                    [class.error]="apiIntegrationForm.get('httpMethod')?.invalid && apiIntegrationForm.get('httpMethod')?.touched"
                    [class.open]="isHttpMethodDropdownOpen()"
                    (click)="toggleHttpMethodDropdown()"
                  >
                    <div class="trigger-content">
                      @if (!apiIntegrationForm.get('httpMethod')?.value) {
                        <span class="placeholder">Select HTTP Method</span>
                      } @else {
                        <span class="selected-value">{{ getSelectedHttpMethod() }}</span>
                      }
                      <svg class="dropdown-arrow" [class.open]="isHttpMethodDropdownOpen()" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                  @if (isHttpMethodDropdownOpen()) {
                    <div class="custom-dropdown-panel">
                      @for (method of httpMethodOptions; track method) {
                        <div
                          class="dropdown-option"
                          [class.selected]="isHttpMethodSelected(method)"
                          (click)="selectHttpMethod(method)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isHttpMethodSelected(method)"></div>
                          </div>
                          <span class="option-label">{{ method }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (apiIntegrationForm.get('httpMethod')?.invalid && apiIntegrationForm.get('httpMethod')?.touched) {
                  <div class="error-message">HTTP Method is required</div>
                }
              </div>
            </div>

            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-api-headers" class="form-label">Custom Headers</label>
                <textarea
                  id="ngsild-api-headers"
                  formControlName="customHeaders"
                  class="form-textarea"
                  rows="3"
                  placeholder="Optional JSON object for extra HTTP headers, such as Authorization or Accept"
                ></textarea>
              </div>
              <div class="form-field col-6">
                <label for="ngsild-api-query" class="form-label">Query Parameters</label>
                <textarea
                  id="ngsild-api-query"
                  formControlName="queryParameters"
                  class="form-textarea"
                  rows="3"
                  placeholder="Optional JSON object for URL parameters, such as limit, offset, or filters"
                ></textarea>
              </div>
            </div>

            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-api-body" class="form-label">Body Payload</label>
                <textarea
                  id="ngsild-api-body"
                  formControlName="bodyPayload"
                  class="form-textarea"
                  rows="3"
                  placeholder="Optional JSON request body for POST, PUT, or PATCH; leave empty for GET"
                ></textarea>
              </div>
              <div class="form-field col-6">
                <label for="ngsild-api-auth-details" class="form-label">Authentication Details</label>
                <textarea
                  id="ngsild-api-auth-details"
                  formControlName="authenticationDetails"
                  class="form-textarea"
                  rows="3"
                  placeholder="Enter authentication details"
                ></textarea>
              </div>
            </div>

            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-api-auth-type" class="form-label">
                  Authentication Type <span class="required">*</span>
                </label>
                <div class="custom-dropdown-wrapper">
                  <div
                    id="ngsild-api-auth-type"
                    class="custom-dropdown-trigger"
                    [class.error]="apiIntegrationForm.get('authenticationType')?.invalid && apiIntegrationForm.get('authenticationType')?.touched"
                    [class.open]="isAuthenticationTypeDropdownOpen()"
                    (click)="toggleAuthenticationTypeDropdown()"
                  >
                    <div class="trigger-content">
                      @if (!apiIntegrationForm.get('authenticationType')?.value) {
                        <span class="placeholder">Select Authentication Type</span>
                      } @else {
                        <span class="selected-value">{{ getSelectedAuthenticationType() }}</span>
                      }
                      <svg class="dropdown-arrow" [class.open]="isAuthenticationTypeDropdownOpen()" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                  @if (isAuthenticationTypeDropdownOpen()) {
                    <div class="custom-dropdown-panel">
                      @for (type of authenticationTypeOptions; track type) {
                        <div
                          class="dropdown-option"
                          [class.selected]="isAuthenticationTypeSelected(type)"
                          (click)="selectAuthenticationType(type)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isAuthenticationTypeSelected(type)"></div>
                          </div>
                          <span class="option-label">{{ type }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (apiIntegrationForm.get('authenticationType')?.invalid && apiIntegrationForm.get('authenticationType')?.touched) {
                  <div class="error-message">Authentication Type is required</div>
                }
              </div>
              <div class="form-field col-6">
                <label for="ngsild-api-response-format" class="form-label">
                  Response Format <span class="required">*</span>
                </label>
                <div class="custom-dropdown-wrapper">
                  <div
                    id="ngsild-api-response-format"
                    class="custom-dropdown-trigger"
                    [class.error]="apiIntegrationForm.get('responseFormat')?.invalid && apiIntegrationForm.get('responseFormat')?.touched"
                    [class.open]="isResponseFormatDropdownOpen()"
                    (click)="toggleResponseFormatDropdown()"
                  >
                    <div class="trigger-content">
                      @if (!apiIntegrationForm.get('responseFormat')?.value) {
                        <span class="placeholder">Select Response Format</span>
                      } @else {
                        <span class="selected-value">{{ getSelectedResponseFormat() }}</span>
                      }
                      <svg class="dropdown-arrow" [class.open]="isResponseFormatDropdownOpen()" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                  @if (isResponseFormatDropdownOpen()) {
                    <div class="custom-dropdown-panel">
                      @for (format of responseFormatOptions; track format) {
                        <div
                          class="dropdown-option"
                          [class.selected]="isResponseFormatSelected(format)"
                          (click)="selectResponseFormat(format)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isResponseFormatSelected(format)"></div>
                          </div>
                          <span class="option-label">{{ format }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (apiIntegrationForm.get('responseFormat')?.invalid && apiIntegrationForm.get('responseFormat')?.touched) {
                  <div class="error-message">Response Format is required</div>
                }
              </div>
            </div>

            <div class="form-row">
              <div class="form-field col-6">
                <label for="ngsild-api-data-path" class="form-label">
                  Data Path in Response <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="ngsild-api-data-path"
                  formControlName="dataPathInResponse"
                  class="form-input"
                  placeholder="Enter data path (e.g., $.data.items)"
                />
                @if (apiIntegrationForm.get('dataPathInResponse')?.invalid && apiIntegrationForm.get('dataPathInResponse')?.touched) {
                  <div class="error-message">Data Path in Response is required</div>
                }
              </div>
              <div class="form-field col-6">
                <label for="ngsild-api-pull-freq" class="form-label">
                  Expected Pull Frequency <span class="required">*</span>
                </label>
                <input
                  type="text"
                  id="ngsild-api-pull-freq"
                  formControlName="expectedPullFrequency"
                  class="form-input"
                  placeholder="Enter pull frequency (e.g., daily, weekly, monthly)"
                />
                @if (apiIntegrationForm.get('expectedPullFrequency')?.invalid && apiIntegrationForm.get('expectedPullFrequency')?.touched) {
                  <div class="error-message">Expected Pull Frequency is required</div>
                }
              </div>
            </div>

            <div class="form-field">
              <label for="ngsild-api-additional-notes" class="form-label">Additional Notes</label>
              <textarea
                id="ngsild-api-additional-notes"
                formControlName="additionalNotes"
                class="form-textarea"
                rows="4"
                placeholder="Additional notes about the API integration"
              ></textarea>
            </div>
          </div>
        </form>
      </div>
    }

    @if (isDirectPushSelected()) {
      <div class="direct-push-section">
        <div class="code-snippet-header">
          <h3 class="code-snippet-title">Python Upload Script</h3>
          <p class="code-snippet-subtitle">Copy or download the script to upload files directly to the platform</p>
        </div>

        <div class="code-snippet-actions">
          <button type="button" class="btn btn-secondary" (click)="copyCodeToClipboard()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.5 3.5H3.5C2.67157 3.5 2 4.17157 2 5V12.5C2 13.3284 2.67157 14 3.5 14H11C11.8284 14 12.5 13.3284 12.5 12.5V10.5M5.5 3.5C5.5 2.67157 6.17157 2 7 2H9.5C10.3284 2 11 2.67157 11 3.5V5.5M5.5 3.5C5.5 4.32843 6.17157 5 7 5H9.5C10.3284 5 11 4.32843 11 3.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Copy Code
          </button>
          <button type="button" class="btn btn-primary" (click)="downloadCode()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 11V2M8 11L5 8M8 11L11 8M2 13.5H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Download
          </button>
        </div>

        <div class="code-snippet-container">
          <pre class="code-snippet"><code>{{ directPushCode }}</code></pre>
        </div>
      </div>
    }

        }

    @if (layout() === 'default') {
    <div class="form-actions">
      @if (isSftpUploadSelected()) {
        <button type="button" class="btn btn-primary" [disabled]="sftpForm.invalid" (click)="onSubmitSftpForm()">Submit</button>
      }
      @if (isApiIntegrationSelected()) {
        <button type="button" class="btn btn-primary" [disabled]="apiIntegrationForm.invalid" (click)="onSubmitApiIntegrationForm()">
          Submit
        </button>
      }
      @if (isDirectPushSelected()) {
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="isPublishing()"
          (click)="onSubmitDirectPush()"
        >
          @if (isPublishing()) {
            Submitting…
          } @else {
            Submit
          }
        </button>
      }
    </div>
    }
      </div>
    </div>

    @if (layout() === 'modal') {
      <footer class="add-data-modal__footer">
        @if (showModalPreviousButton()) {
          <button type="button" class="btn-add-data btn-add-data--secondary" (click)="onModalPrevious()">
            ← Previous
          </button>
        }
        <button
          type="button"
          class="btn-add-data"
          [class.btn-add-data--primary]="!isExistingDataSourceReadOnly()"
          [class.btn-add-data--secondary]="isExistingDataSourceReadOnly()"
          [disabled]="!canModalPublish()"
          (click)="onModalFooterPrimary()"
        >
          @if (!isExistingDataSourceReadOnly() && isConnectingDataSource()) {
            Connecting…
          } @else if (!isExistingDataSourceReadOnly() && isPublishing()) {
            Submitting…
          } @else {
            {{ modalPrimaryFooterLabel() }}
          }
        </button>
      </footer>
    }
  </div>
</div>

@if (tabSwitchConfirmTarget()) {
  <div
    class="ngsild-tab-switch-confirm-backdrop"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ngsild-tab-switch-confirm-title"
    (keydown)="$event.stopPropagation()"
  >
    <div class="ngsild-tab-switch-confirm-backdrop__shade" (click)="cancelTabSwitch()"></div>
    <div class="ngsild-tab-switch-confirm-dialog" (click)="$event.stopPropagation()">
      <p id="ngsild-tab-switch-confirm-title" class="ngsild-tab-switch-confirm-dialog__message">
        Are you sure you want to switch the upload method?
      </p>
      <div class="ngsild-tab-switch-confirm-dialog__actions">
        <button
          type="button"
          class="ngsild-tab-switch-confirm-dialog__btn ngsild-tab-switch-confirm-dialog__btn--secondary"
          (click)="cancelTabSwitch()"
        >
          No
        </button>
        <button
          type="button"
          class="ngsild-tab-switch-confirm-dialog__btn ngsild-tab-switch-confirm-dialog__btn--primary"
          (click)="confirmTabSwitch()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
}

@if (isUploadSuccessModalOpen()) {
  <div
    class="ngsild-upload-success-backdrop"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ngsild-upload-success-title"
  >
    <div class="ngsild-upload-success-backdrop__shade" (click)="closeUploadSuccessModal()"></div>
    <div class="ngsild-upload-success-dialog" (click)="$event.stopPropagation()">
      <h3 id="ngsild-upload-success-title" class="ngsild-upload-success-dialog__title">Success</h3>
      <div class="success-modal-content">
        <div class="success-icon-wrapper">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#4caf50" opacity="0.1" />
            <path d="M20 32L28 40L44 24" stroke="#4caf50" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <h3 class="success-title">Direct Push configured</h3>
        <p class="success-message">
          No files have been uploaded yet. Use the Python script above to push files to your dataset when you are ready.
        </p>
      </div>
      <button type="button" class="btn btn-primary ngsild-upload-success-dialog__ok" (click)="closeUploadSuccessModal()">OK</button>
    </div>
  </div>
}

@if (previewModalOpen()) {
  <div
    class="ngsild-upload-preview-backdrop"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'ngsild-upload-preview-title'"
  >
    <div class="ngsild-upload-preview-backdrop__shade" (click)="closePreview()"></div>
    <div class="ngsild-upload-preview-dialog" (click)="$event.stopPropagation()">
      <header class="ngsild-upload-preview-dialog__header">
        <h3 id="ngsild-upload-preview-title" class="ngsild-upload-preview-dialog__title">
          File Preview: {{ previewingFile()?.name }}
        </h3>
        <button
          type="button"
          class="ngsild-upload-preview-dialog__close"
          (click)="closePreview()"
          aria-label="Close preview"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </header>
      @if (previewingFile(); as preview) {
        <div class="ngsild-upload-preview-dialog__body">
          <div class="ngsild-upload-preview-meta">
            <div class="ngsild-upload-preview-meta__item">
              <span class="ngsild-upload-preview-meta__label">File name</span>
              <span class="ngsild-upload-preview-meta__value">{{ preview.name }}</span>
            </div>
            <div class="ngsild-upload-preview-meta__item">
              <span class="ngsild-upload-preview-meta__label">Size</span>
              <span class="ngsild-upload-preview-meta__value">{{ getFileSize(preview.size) }}</span>
            </div>
            <div class="ngsild-upload-preview-meta__item">
              <span class="ngsild-upload-preview-meta__label">Type</span>
              <span class="ngsild-upload-preview-meta__value">{{ preview.type || 'Unknown' }}</span>
            </div>
          </div>
          <div class="ngsild-upload-preview-content">
            @if (preview.parsedData && preview.parsedData.headers.length > 0) {
              <div class="ngsild-upload-preview-table-wrap">
                <table class="ngsild-upload-preview-table">
                  <thead>
                    <tr>
                      @for (header of preview.parsedData.headers; track header) {
                        <th>{{ header }}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of preview.parsedData.rows; track $index) {
                      <tr>
                        @for (cell of row; track $index) {
                          <td>{{ cell }}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else if (preview.rawText != null) {
              <div class="ngsild-upload-preview-text">
                <pre>{{ preview.rawText || '(empty file)' }}</pre>
              </div>
            } @else if (preview.previewUnavailableReason) {
              <p class="ngsild-upload-preview-empty">{{ preview.previewUnavailableReason }}</p>
            } @else if (preview.previewData) {
              <div class="ngsild-upload-preview-json">
                <pre>{{ preview.previewData | json }}</pre>
              </div>
            } @else {
              <p class="ngsild-upload-preview-empty">Preview not available for this file.</p>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

